<script>
    import { format } from "svelte-i18n";
    import campaignService from "../service.js";
    import { notificate } from "../../../../services/notification.js";

    let { campaign = {}, onclose } = $props();

    let reportLanguage = $state("es");
    let isDownloading = $state(false);
    let downloadError = $state(null);

    async function handleDownloadReport() {
        if (!campaign?.id) return;
        isDownloading = true;
        downloadError = null;

        try {
            await campaignService.downloadReportFile(campaign, reportLanguage);
            notificate("save_ok", "toast", { data: $format("phishing.campaign.download_report") });
        } catch (err) {
            console.error("Error downloading report:", err);
            downloadError = err?.message || "Error al descargar el reporte";
            notificate("save_error", "toast", { data: $format("phishing.campaign.download_report") });
        } finally {
            isDownloading = false;
        }
    }

    function handleClose() {
        downloadError = null;
        if (onclose) onclose();
    }
</script>

<div class="modal-header">
    <h4 class="modal-title">
        <i class="fas fa-file-contract text-primary me-2"></i>
        {$format("phishing.campaign.report_section_title")}
        {#if campaign?.name}
            - <span class="text-primary">{campaign.name}</span>
        {/if}
    </h4>
    <button
        type="button"
        class="btn-close"
        onclick={handleClose}
        aria-label="Close"
    ></button>
</div>

<div class="modal-body">
    <!-- Campaign Stats Summary Row with Required Colors:
         Sent: blue, Opened: orange, Clicked: red, Credentials: purple, Reported: green -->
    <div class="p-3 bg-light rounded mb-4 border d-flex flex-wrap gap-2 justify-content-between align-items-center">
        <div>
            <strong>{$format("phishing.campaign.singular")}:</strong>
            <span>{campaign?.name || "-"}</span>
            {#if campaign?.description}
                <div class="text-muted small">{campaign.description}</div>
            {/if}
        </div>
        <div class="d-flex flex-wrap gap-2">
            <span>
                {$format("phishing.campaign.sent_count")}: {@html campaign?.sent_count ?? 0}
            </span>
            <span>
                {$format("phishing.campaign.opened_count")}: {@html campaign?.opened_count ?? 0}
            </span>
            <span>
                {$format("phishing.campaign.clicked_count")}: {@html campaign?.clicked_count ?? 0}
            </span>
            <span>
                {$format("phishing.campaign.submitted_count")}: {@html campaign?.submitted_count ?? 0}
            </span>
            <span>
                {$format("phishing.campaign.reported_count")}: {@html campaign?.reported_count ?? 0}
            </span>
        </div>
    </div>

    <!-- REPORT DOWNLOAD SECTION -->
    <div class="section-container">
        <p class="text-muted small mb-3">
            {$format("phishing.campaign.report_section_desc")}
        </p>

        <div class="card bg-light border-0">
            <div class="card-body py-3">
                <div class="row align-items-center g-3">
                    <div class="col-auto">
                        <label class="form-label small fw-bold mb-0 me-2" for="reportLangGroup">
                            {$format("phishing.campaign.report_language")}:
                        </label>
                        <div class="btn-group btn-group-sm" id="reportLangGroup" role="group">
                            <button
                                type="button"
                                class="btn {reportLanguage === 'es' ? 'btn-primary' : 'btn-outline-primary'}"
                                onclick={() => (reportLanguage = "es")}
                            >
                                {$format("page.report.options.spanish")}
                            </button>
                            <button
                                type="button"
                                class="btn {reportLanguage === 'en' ? 'btn-primary' : 'btn-outline-primary'}"
                                onclick={() => (reportLanguage = "en")}
                            >
                                {$format("page.report.options.english")}
                            </button>
                        </div>
                    </div>

                    <div class="col-auto">
                        <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            onclick={handleDownloadReport}
                            disabled={isDownloading}
                        >
                            {#if isDownloading}
                                <i class="fas fa-sync-alt fa-spin me-1"></i>
                                {$format("phishing.campaign.downloading")}
                            {:else}
                                <i class="fas fa-file-download me-1"></i>
                                {$format("phishing.campaign.download_html")}
                            {/if}
                        </button>
                    </div>
                </div>

                {#if downloadError}
                    <div class="alert alert-danger py-2 mt-2 mb-0 small">
                        {downloadError}
                    </div>
                {/if}
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-default" onclick={handleClose}>
        {$format("buttons.cancel")}
    </button>
</div>

<style>
    .badge-opened {
        background-color: #fd7e14;
        color: #fff;
    }

    .badge-credentials {
        background-color: #6f42c1;
        color: #fff;
    }
</style>
